import { Button, CardContent, cn } from '@sandtech-hub-monorepo/ui-kit';

/**
 * Visual overrides for `ProfileEmptySection`, grouped so callers pass one
 * bundle instead of four/five loose className props. Every field defaults to
 * central-hub's original look, so an omitted `emptyStateStyling` leaves ALX
 * untouched; FIT call sites pass one bundle (Figma 10708-66006) shared across
 * Skills/Languages/Portfolio.
 */
export interface EmptyStateStyling {
  /** Heading colour. Defaults to the fixed cyan this component shipped with in central-hub. */
  headerClassName?: string;
  /** Heading sizing/spacing, separate from `headerClassName`'s colour. */
  headerSizeClassName?: string;
  /** Wrapper around the icon. Defaults to central-hub's plain 128px icon with no background. */
  iconWrapperClassName?: string;
  /** Icon shown before the call-to-action text on the button. Omitted by default (ALX). */
  ctaIcon?: JSX.Element;
  /** Defaults to central-hub's full-width-on-mobile button. */
  buttonClassName?: string;
}

interface AboutYouEmptyProps extends EmptyStateStyling {
  header: string;
  main: string;
  callToAction: () => void;
  callToActionText: string;
  icon: JSX.Element;
}
export default function ProfileEmptySection({
  header,
  main,
  callToAction,
  callToActionText,
  icon,
  headerClassName = 'text-[#029DE099]',
  headerSizeClassName = 'text-lg mb-2',
  iconWrapperClassName = 'w-32 h-32 flex items-center justify-center',
  ctaIcon,
  buttonClassName = 'w-full sm:w-auto',
}: AboutYouEmptyProps) {
  return (
    <CardContent className="flex flex-col items-center text-center h-full">
      <div className={iconWrapperClassName}>{icon}</div>
      <p className={cn('font-medium', headerSizeClassName, headerClassName)}>
        {header}
      </p>
      <p className="text-sm text-muted-foreground mb-6">{main}</p>
      <Button
        className={cn('gap-2 mt-auto', buttonClassName)}
        variant="outline"
        onClick={() => callToAction()}
      >
        {ctaIcon}
        {callToActionText}
      </Button>
    </CardContent>
  );
}
